import { render, staticRenderFns } from "./hasPosition.vue?vue&type=template&id=a66455f8&scoped=true"
import script from "./hasPosition.vue?vue&type=script&lang=js"
export * from "./hasPosition.vue?vue&type=script&lang=js"
import style0 from "./hasPosition.vue?vue&type=style&index=0&id=a66455f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66455f8",
  null
  
)

export default component.exports